import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { MensagemChamado } from 'src/app/admihair/api/dto/mensagem-chamado';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { AdmihairBaseComponent } from 'src/app/admihair/components/admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { MensagemChamadoService } from 'src/app/admihair/service/mensagem-chamado.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-base-conhecimento-listar',
  templateUrl: './base-conhecimento-listar.component.html',
  styleUrls: ['./base-conhecimento-listar.component.scss']
})
export class BaseConhecimentoListarComponent extends AdmihairBaseComponent implements OnInit {

  loading: boolean = false;

  pageBaseConhecimento: Paginador<MensagemChamado> = {
    size: 5,
    content: [],
    number: 0,
    totalElements: 0,
    totalPages: 0
  }

  inputBusca?: string = '';
  numeroPagina: number = 0;
  tamanhoPagina: number = 10;
  linhasTabela: number = 10;
  ordenacao: string = 'dataCriacao,DESC';

  listaTiposAtendimento: SelectItem[] = [
    { label: 'TODOS', value: 'TODOS' },
    { label: 'ERRO', value: 'ERRO' },
    { label: 'DÚVIDA', value: 'DUVIDA' },
    { label: 'SOLICITAÇÃO DE FUNCIONALIDADE', value: 'SOLICITACAO_FUNCIONALIDADE' },
    { label: 'PROBLEMA DE DESEMPENHO', value: 'PROBLEMA_DESEMPENHO' },
    { label: 'ACESSO/PERMISSÃO', value: 'ACESSO_PERMISSAO' },
    { label: 'TREINAMENTO/CAPACITAÇÃO', value: 'TREINAMENTO_CAPACITACAO' },
    { label: 'INSTALACÃO/CONFIGURAÇÃO', value: 'INSTALACAO_CONFIGURACAO' },
    { label: 'SOLICITAÇÃO DE DOCUMENTO', value: 'SOLICITACAO_DOCUMENTO' },
    { label: 'SOLICITAÇÃO DE INFORMAÇÕES COMPLEMENTARES', value: 'SOLICITACAO_INFORMACOES_COMPLEMENTARES' },
    { label: 'OUTRO', value: 'OUTRO' },
  ]
  tipoAtendimentoSelecionado: string = 'TODOS';

  @ViewChild('filter') filter!: ElementRef;

  constructor(
    private mensagemChamadoService: MensagemChamadoService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router?: Router,
    activatedRoute?: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    //this.listarBaseConhecimento();
  }

  listarBaseConhecimento() {
    this.loading = true;
    this.mensagemChamadoService.listarBaseConhecimentoPorAdministradoraId(
      this.getAdministradora().id,
      this.numeroPagina,
      this.tamanhoPagina,
      this.ordenacao,
      this.inputBusca,
      this.tipoAtendimentoSelecionado
    ).subscribe({
      next: (data: Paginador<MensagemChamado>) => {
        this.pageBaseConhecimento = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }


  onLazyLoad(event: LazyLoadEvent) {
    if (event.first !== undefined && event.rows !== undefined) {
      if (event.first === 0 && event.rows === 0) {
        this.numeroPagina = 0;
      } else {
        this.numeroPagina = event.first / event.rows;
      }
    }
    this.definirOrdenacao(event.sortField, event.sortOrder);
    this.loading = true;
    this.listarBaseConhecimento();
  }

  definirOrdenacao(sortField?: string, sortOrder?: number) {
    if (sortField && sortOrder) {
      const campoDeOrdenacao = sortField ? sortField : 'dataCriacao';
      const direcaoOrdenacao = sortOrder === -1 ? 'DESC' : 'ASC';
      this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
    } else {
      this.ordenacao = 'dataCriacao,DESC';
    }
  }

  alterarFiltro(table: Table) {
    table.clear();
  }

  buscar(table: Table, event: Event) {
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.numeroPagina = 0;
    table.clear();
  }

  limpar(table: Table) {
    this.inputBusca = '';
    table.reset();
  }

}
